// extracted by mini-css-extract-plugin
module.exports = {"list":"SidebarLinks_list_3IxaB","root":"SidebarLinks_root_3N-bB","children":"SidebarLinks_children_38Qlg"};